<div class="banner">
  <div>
    <h1>
      Checkout Payment
    </h1>
  </div>
</div>

<div class="tabcontent">
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>

  <div class="d-flex justify-content-end">
    <div class="float-end">
      <button id="topcompletePayment" type="submit" class="btn btn-primary me-3" appPreventDoubleClick [throttleTime]="3000" (throttledClick)="completePayment()">
        Complete Payment
      </button>
      <button id="topcancelPayment" class="btn btn-secondary" type="button" (click)="cancelPayment()">
        Cancel
      </button>
    </div>
  </div>
  <form [formGroup]="form" (keydown.enter)="handleEnterKeyPress($event)">

    <app-payment-review [payment]="payment" [checkoutState]="checkoutState"></app-payment-review>

    <app-paymentinformation [form]="form" [submitted]="submitted" [checkoutState]="checkoutState"></app-paymentinformation>

    <app-billinginformation [form]="form" [submitted]="submitted" [defaults]="paymentDefaults"></app-billinginformation>

    <app-purchaseordernumber [form]="form" [submitted]="submitted"></app-purchaseordernumber>

    <app-autorenew-confirmation [form]="form" [submitted]="submitted"></app-autorenew-confirmation>

    <app-monthlybilling-confirmation *ngIf="showMonthlyBillingConfirmation" [form]="form" [submitted]="submitted"></app-monthlybilling-confirmation>

    <app-sla-agreement [form]="form" [submitted]="submitted"></app-sla-agreement>

    <div class="footer mt-3">
      <div class="float-end">
        <button id="completePayment" type="submit" class="btn btn-primary me-3" appPreventDoubleClick [throttleTime]="3000" (throttledClick)="completePayment()">
          Complete Payment
        </button>
        <button id="cancelPayment" class="btn btn-secondary" type="button" (click)="cancelPayment()">
          Cancel
        </button>
      </div>
    </div>
  </form>

</div>